<template>
  <div class='tld-order-confirm'>
    <!-- 顶部提示 -->
    <img src='../../assets/img/telaidian/img-remind.png' class='remind-icon' />

    <!-- 订单信息卡片 -->
    <div class='order-card'>
      <div class='order-row'>
        <span class='row-label'>充值账号</span>
        <span class='row-value'>{{ chargeAccount }}</span>
      </div>
      <div class='order-row'>
        <span class='row-label'>产品名称</span>
        <span class='row-value'>{{ productName }}</span>
      </div>
      <div class='order-row'>
        <span class='row-label'>充值金额</span>
        <span class='row-value price'>¥ {{ facePrice }}</span>
      </div>
    </div>

    <!-- 支付说明 -->
    <div class='pay-notes'>
      <div class='notes-content' v-html='description'></div>
    </div>

    <!-- 底部按钮 -->
    <div class='bottom-bar'>
      <van-button
        type='primary'
        :loading='payLoading'
        loading-type='spinner'
        @click='handlePay'
        class='submit-btn'
      >
        ¥ {{ salePrice }} 确认支付
      </van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { busiDescDetail, tldToPay } from '@/api/telaidian'

export default {
  name: 'TldOrderConfirm',
  data() {
    return {
      chargeAccount: '',
      productName: '',
      facePrice: '',
      salePrice: '',
      id: '',
      productType: '',
      payLoading: false,
      description: '' // 充值说明
    }
  },
  created() {
    this.getOrderInfo()
    this.getDescription()
  },
  methods: {
    // 从路由参数获取订单信息
    getOrderInfo() {
      const query = this.$route.query
      this.chargeAccount = query.chargeAccount || ''
      this.productName = query.productName || ''
      this.facePrice = query.facePrice || ''
      this.salePrice = query.salePrice || ''
      this.id = query.id || ''
      this.productType = query.productType || ''
    },
    // 获取充值说明
    getDescription() {
      busiDescDetail('tld_qr').then(res => {
        if (res.code === 200 && res.data) {
          let str
          if (res.data.content.includes('_blank')) {
            str = res.data.content.replaceAll('_blank', '_self')
          } else {
            str = res.data.content
          }
          this.description = str
        }
      })
    },
    // 确认支付
    handlePay() {
      if (!this.chargeAccount) {
        Toast.fail('充值账号不能为空')
        return
      }
      if (!this.id) {
        Toast.fail('面值信息不能为空')
        return
      }

      this.payLoading = true
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      tldToPay({
        id: this.id,
        chargeAccount: this.chargeAccount
      }).then((res) => {
        this.payLoading = false
        this.$toast.clear()
        if (res.code === 200 && res.data) {
          // data 为收银台 URL，直接跳转
          window.location.href = res.data
        }
      }).catch(() => {
        this.payLoading = false
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.tld-order-confirm {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #F5F5F5;
  padding-bottom: 0.8rem;

  // 顶部提示
  .remind-icon {
    width: 100%;
    height: 0.34rem;
    display: block;
  }

  // 订单信息卡片
  .order-card {
    background: white;
    padding: 0.14rem 0.16rem;

    .order-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.14rem 0;
      border-bottom: 0.005rem solid #F4F4F4;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }

      &:first-child {
        padding-top: 0;
      }

      .row-label {
        font-size: 0.15rem;
        color: #666666;
      }

      .row-value {
        font-size: 0.15rem;
        color: #333333;

        &.price {
          font-size: 0.18rem;
          font-weight: bold;
          color: #EC0708;
        }
      }
    }
  }

  // 支付说明
  .pay-notes {
    padding: 0.20rem 0.16rem;

    .notes-content {
      text-align: initial;
      line-height: initial;

      // 避免接口返回的富文本把布局撑爆
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }

      ::v-deep p {
        margin: 0 0 0.08rem 0;
      }

      ::v-deep a {
        color: #1E7DFF;
      }
    }
  }

  // 底部按钮
  .bottom-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    padding: 0.1rem 0.15rem calc(0.1rem + constant(safe-area-inset-bottom));
    padding: 0.1rem 0.15rem calc(0.1rem + env(safe-area-inset-bottom));
    background: white;

    .submit-btn {
      width: 100%;
      height: 0.5rem;
      border-radius: 0.5rem;
      font-size: 0.16rem;
      font-weight: 500;
      background-color: #4379F5;
      border: none;
    }
  }
}
</style>
